// ─── Impostazioni → Regole per i soci (era «Borsellino, Acconto e Crediti») ───
//
// Voce 36, mockup approvato il 27/09/2026 (nome consigliato, strada A). 🗣️
// *«dobbiamo accorpare in una voce unica Borsellino, crediti, acconto. E premio
// per chi organizza. Se no ci perdiamo.»* ⇒ Una voce sola del menu, dove prima
// erano due («Acconto» e «Premio a chi organizza»), e dentro quattro linguette.
//
// 🗂️ Come la Cassa, ogni linguetta è un INDIRIZZO, non uno stato della pagina:
// il vecchio `/impostazioni/premio` porta dritto alla sua, e «indietro» nel
// browser torna dov'era.
//
// 🧹 30/09/2026 (mockup «Via l’Acconto», 1A 2A): la linguetta «Acconto · spento»
// non c'è più. E con il mockup «Premio, Crediti e campi fissi in una sezione»
// (1A 2A) le linguette sono tre: «Crediti» e «Premio a chi organizza» diventano
// «Premio e Crediti», col campo fisso dal bot dentro; gli avvisi
// all'organizzatore stanno in «Disdette», sotto i suoi avvisi.

import { Link } from 'react-router-dom';
import { VALORE_CREDITO_CENTS } from '@pmo/shared';
import { Disdette } from './Disdette.js';
import { PremioECrediti } from './PremioECrediti.js';
import { Tessera } from './Tessera.js';
import { Promoter } from './Promoter.js';
import { euro } from './comune.js';

export type LinguettaBorsellino = 'disdette' | 'borsellino' | 'premio-e-crediti' | 'tessera' | 'promoter';

const LINGUETTE: ReadonlyArray<{ chi: LinguettaBorsellino; dove: string; testo: string }> = [
  // 🚦 Fase B (28/09/2026): le regole della disdetta, per prime.
  { chi: 'disdette', dove: '/impostazioni/borsellino/disdette', testo: 'Disdette' },
  { chi: 'borsellino', dove: '/impostazioni/borsellino', testo: 'Borsellino' },
  { chi: 'premio-e-crediti', dove: '/impostazioni/borsellino/premio-e-crediti', testo: 'Premio e Crediti' },
  // 🪪 16/10/2026: *«dentro la sezione Regole per i soci, con una tab dedicata, chiamata tessera associativa»*.
  { chi: 'tessera', dove: '/impostazioni/borsellino/tessera', testo: 'Tessera associativa' },
  // 🎾 16/10/2026: *«Dentro regole per i soci mi devi costruire una sottosezione che si chiama promoter»*.
  { chi: 'promoter', dove: '/impostazioni/borsellino/promoter', testo: 'Promoter' },
];

export function RegolePerISoci({ linguetta }: { linguetta: LinguettaBorsellino }): React.JSX.Element {
  return (
    <section>
      <header className="testata">
        {/* 🔄 Fase B: era «Borsellino, Acconto e Crediti», poi «Prenotazioni e Borsellino».
            Mockup «Nome della sezione» (30/09/2026), A: le regole per i soci. */}
        <h2>Regole per i soci</h2>
      </header>
      <nav className="linguette-cassa" aria-label="Cosa imposti">
        {LINGUETTE.map((l) => (
          <Link key={l.chi} to={l.dove} aria-current={linguetta === l.chi ? 'page' : undefined}>
            {l.testo}
          </Link>
        ))}
      </nav>
      {linguetta === 'disdette' ? (
        <Disdette />
      ) : linguetta === 'borsellino' ? (
        <IlBorsellino />
      ) : linguetta === 'tessera' ? (
        <Tessera />
      ) : linguetta === 'promoter' ? (
        <Promoter />
      ) : (
        <PremioECrediti />
      )}
    </section>
  );
}

/** Cosa c'è nel borsellino. Gli euro non hanno regole: qui si dice dove si muovono. */
function IlBorsellino(): React.JSX.Element {
  return (
    <div className="riquadro borsellino-spiegato">
      <h3>Cosa c’è nel borsellino di un socio</h3>
      <div className="due-origini">
        <p>
          <strong>💶 Euro.</strong> Li carica in Segreteria e li usa per pagare le quote. Si caricano e si
          scaricano dalla scheda del socio, in <Link to="/soci">Soci</Link> → scheda → Borsellino; ogni
          movimento resta scritto lì e in Cassa. Non ci sono regole da impostare.
        </p>
        <p>
          <strong>🎟️ Crediti.</strong> 1 Credito = {euro(VALORE_CREDITO_CENTS)} di sconto sulla sua quota di
          una partita. Non si prelevano, non si rimborsano e non si passano ad altri. Arrivano dal premio a
          chi organizza; le regole stanno in{' '}
          <Link to="/impostazioni/borsellino/premio-e-crediti">Premio e Crediti</Link>.
        </p>
      </div>
    </div>
  );
}
